<template>
  <div class="app-consumptions">
    <dyn-slot>
      <slot name="txtBefore"></slot>
    </dyn-slot>
    <ConsumptionList
      v-if="consumptions.consumptionsForUnit.length"
      :consumptions="consumptions.consumptionsForUnit"
      :tariff-id="tariffs.bookedTariff.tariffId"
      :show-modal="true"
    >
      <template v-for="slot in possibleChildSlotsFor('Consumptions')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </ConsumptionList>
    <div class="txt-no-booked-tariff" v-else>
      <slot name="txtNoBookedTariff"></slot>
    </div>
    <slot name="txtAfter"></slot>
  </div>
</template>

<script>
import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
import ConsumptionList from './ConsumptionList.vue'
import transaction from '../../../../mixins/transaction'
import slotProxy from '../../../../mixins/slotProxy'

export const stepName = 'view'
export default {
  components: { ConsumptionList },
  data() {
    return {
      consumptions: {
        consumptionsForUnit: []
      },
      tariffs: {
        bookedTariff: {}
      }
    }
  },
  name: 'ConsumptionsWrapper',
  mixins: [transaction('consumptions'), slotProxy()],
  apollo: {
    consumptions: function() {
      return wrapQuery(
        gql`
          query consumptions {
            consumptions {
              consumptionsForUnit {
                consumed
                unit
                formattedUnit
                type
                description
                expirationDate
                left
                max
                tariffOrOptions {
                  name
                  id
                  type
                  consumptions {
                    consumed
                    unit
                    formattedUnit
                    type
                    description
                    expirationDate
                    left
                    max
                  }
                }
              }
            }
          }
        `,
        this,
        'consumptions',
        {},
        null,
        { fetchPolicy: 'no-cache' }
      )
    },
    tariffs: function() {
      return wrapQuery(
        gql`
          query {
            tariffs {
              bookedTariff {
                tariffId
              }
            }
          }
        `,
        this,
        'tariffs'
      )
    }
  }
}
</script>
